import { render, staticRenderFns } from "./newinfo.vue?vue&type=template&id=2c981762&scoped=true"
import script from "./newinfo.vue?vue&type=script&lang=js"
export * from "./newinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c981762",
  null
  
)

export default component.exports